module.exports = __webpack_public_path__ + "static/media/HindVadodara-Medium.9b3a0b8f.eot";